<template>
    <VueFinalModal 
            class="modal"
            content-class="modal-content"
            overlay-transition="vfm-fade"
            :clickToClose="false"
            @opened="clearSelection"
            @click-outside="emit('close')">
        <TileCard :loaded="settingsStore.getServicesLoaded" class="tile-card">
            <template #body>
                <TeamPropertiesForm :team="props.team"></TeamPropertiesForm>         
            </template>                
        </TileCard>        
        <div class="buttons">
            <button class="accent" @click="emit('close')">Cancel</button>
            <button class="accent" @click="emit('create')" :disabled="!canCreate()" >Create</button>
        </div>
    </VueFinalModal>
</template>

<script lang="ts" setup>
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import TeamPropertiesForm from '@/components/service_teams/forms/TeamPropertisForm.vue';
import { VueFinalModal } from 'vue-final-modal';
import TileCard from '@/components/util/TileCard.vue';
import { onMounted } from 'vue';
import { useSettingsStore } from '@/stores/setting';

const settingsStore = useSettingsStore();
const emit = defineEmits(["close", "create"]);
const props = defineProps({
    team: {Type: {} as ServiceTeamItem, default: {} as ServiceTeamItem},    
});


onMounted(async () => {
    await settingsStore.loadServices();
});


function clearSelection() {

}


function canCreate() {
    return (props.team.teamName != null && props.team.teamName.length > 0)
        && ((props.team.service != null && props.team.service.id != null));
}
</script>

<style lang="scss" scoped>
.tile-card {
    overflow: auto;
    height: calc(100vh / 2);
}
</style>